import React, { useState, useEffect, useRef } from "react"
import "./footer.css"

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false)
  const widgetRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (widgetRef.current && !widgetRef.current.contains(e.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener("click", handleClickOutside)
    return () => document.removeEventListener("click", handleClickOutside)
  }, [])

  const waIcon = (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  )

  return (
    <div className="whatsapp-widget" ref={widgetRef}>
      {isOpen && (
        <div className="whatsapp-chatbox">
          <div className="chatbox-header">
            <div className="chatbox-avatar">{waIcon}</div>
            <div className="chatbox-info">
              <h3>Rovers Access Limited</h3>
              <p>Typically replies within minutes</p>
            </div>
            <button className="chatbox-close" onClick={() => setIsOpen(false)}>×</button>
          </div>
          <div className="chatbox-body">
            <div className="chat-message">
              Hello! Welcome to Rovers Access Limited. How can we help you today?
            </div>
          </div>
          <div className="chatbox-footer">
            <a
              href="https://wa.me/254723000200?text=Hello%20Rovers%20Access%20Limited%2C%20I%20would%20like%20to%20inquire%20about%20your%20services."
              target="_blank"
              rel="noreferrer"
              className="chatbox-start-btn"
            >
              {waIcon}
              Start Chat
            </a>
          </div>
        </div>
      )}
      <div className="whatsapp-button" onClick={() => setIsOpen((prev) => !prev)}>
        <span className="whatsapp-tooltip">Chat on WhatsApp</span>
        {waIcon}
      </div>
    </div>
  )
}

const Footer = () => {
  return (
    <>
      {/* Newsletter bar */}
      <section className='newletter'>
        <div className='container flexSB'>
          <div className='left row'>
            <h1>Stay Updated — Market Insights &amp; Trading Tips</h1>
            <span>Subscribe for weekly market reviews, trading tips, and programme updates.</span>
          </div>
          <div className='right row'>
            <input type='text' placeholder='Enter your email address' />
            <i className='fa fa-paper-plane'></i>
          </div>
        </div>
      </section>

      {/* Main footer */}
      <footer>
        <div className='container padding footer-grid'>

          {/* Col 1 — Brand */}
          <div className='footer-brand'>
            <div className='footer-logo-row'>
              <img src='/images/logo.png' alt='Rovers Access Limited' className='footer-logo-img' />
              <div className='footer-logo-text'>
                <h2>Rovers Access Limited</h2>
                <span>Learn | Trade | Grow</span>
              </div>
            </div>
            <p>Africa's practical trading education hub. We transform financial curiosity into confident, disciplined market participation. Headquartered in Nairobi, Kenya.</p>
            <div className='footer-socials'>
              <i className='fab fa-facebook-f icon'></i>
              <i className='fab fa-twitter icon'></i>
              <i className='fab fa-instagram icon'></i>
              <i className='fab fa-linkedin-in icon'></i>
            </div>
          </div>

          {/* Col 2 — Explore */}
          <div className='footer-col'>
            <h3>Explore</h3>
            <ul>
              <li><a href='/about'>About Us</a></li>
              <li><a href='/courses'>Our Programmes</a></li>
              <li><a href='/live'>Live Sessions</a></li>
              <li><a href='/journal'>Trading Journal</a></li>
              <li><a href='/team'>Meet the Team</a></li>
              <li><a href='/contact'>Contact Us</a></li>
            </ul>
          </div>

          {/* Col 3 — Programmes */}
          <div className='footer-col'>
            <h3>Our Programmes</h3>
            <ul>
              <li><a href='/courses'>Beginner Trading Course</a></li>
              <li><a href='/courses'>Intermediate Trader Program</a></li>
              <li><a href='/courses'>Professional Mentorship</a></li>
              <li><a href='/courses'>Signature Programme</a></li>
              <li><a href='/contact'>Corporate Workshops</a></li>
            </ul>
          </div>

          {/* Col 4 — Contact */}
          <div className='footer-col footer-contact'>
            <h3>Contact Us</h3>
            <ul>
              <li>
                <i className='fa fa-phone-alt'></i>
                <span>+254 723 000 200</span>
              </li>
              <li>
                <i className='fa fa-envelope'></i>
                <a href='mailto:info@rovers.ke'>info@rovers.ke</a>
              </li>
              <li>
                <i className='fa fa-globe'></i>
                <a href='https://www.rovers.ke' target='_blank' rel='noreferrer'>www.rovers.ke</a>
              </li>
              <li>
                <i className='fa fa-map-marker-alt'></i>
                <span>Victoria Plaza, Westlands Nairobi, Kenya</span>
              </li>
            </ul>
            <div className='footer-hours'>
              <h4><i className='fa fa-clock'></i> Training Hours</h4>
              <p><span>Mon – Fri:</span> 8:00 AM – 6:00 PM</p>
              <p><span>Saturday:</span> 9:00 AM – 1:00 PM</p>
              <p className='timezone'>EAT (UTC+3)</p>
            </div>
          </div>

        </div>
      </footer>

      {/* Legal bar */}
      <div className='legal'>
        <p>© 2026 <strong>Rovers Access Limited</strong>. All rights reserved. &nbsp;|&nbsp; Learn · Trade · Grow</p>
      </div>

      <WhatsAppWidget />
    </>
  )
}

export default Footer
